import { render, staticRenderFns } from "./RouteIndex.vue?vue&type=template&id=31beaafa&scoped=true"
import script from "./RouteIndex.vue?vue&type=script&lang=js"
export * from "./RouteIndex.vue?vue&type=script&lang=js"
import style0 from "./RouteIndex.vue?vue&type=style&index=0&id=31beaafa&prod&lang=css"
import style1 from "./RouteIndex.vue?vue&type=style&index=1&id=31beaafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31beaafa",
  null
  
)

export default component.exports